import React, { FC } from 'react';

import { Card, CardCloseButton, CardOptions, DetailList } from '@/components';
import { WelcomeOffersQuery } from './__generated__/useWelcomeOffers';

type RewardTemplate = NonNullable<
  NonNullable<
    NonNullable<WelcomeOffersQuery['viewer']['welcomeOffers']['edges']>[0]
  >['node']['rewardTemplates'][0]
>;

const getTypeSpecificItems = (template: RewardTemplate) => {
  switch (template.__typename) {
    case 'FreespinsTemplate':
      return [
        {
          label: 'Game Provider',
          value: template.gameProvider || '-',
        },
        {
          label: 'Game ID',
          value: template.gameId || '-',
        },
        {
          label: 'Spread Over Days',
          value: template.spreadOverDays?.toString() || '-',
        },
        {
          label: 'Pay Lines',
          value: template.payLines?.toString() || '-',
        },
        {
          label: 'Value Cents',
          value: template.valueCents?.toString() || '-',
        },
      ];
    case 'BonusMoneyTemplate':
      const items = [
        {
          label: 'Wagering Requirement Factor',
          value: template.wageringRequirementFactor
            ? `${template.wageringRequirementFactor}x`
            : '-',
        },
        {
          label: 'Static Max Payout',
          value: template.staticMaxPayout?.toString() || '-',
        },
      ];
      if (template.dynamicMaxPayoutMultiplier) {
        items.push({
          label: 'Dynamic Max Payout Multiplier',
          value: `x${template.dynamicMaxPayoutMultiplier}`,
        });
      }
      return items;
    case 'MoneyTemplate':
    default:
      return [];
  }
};

const RewardTemplates: FC<{
  name: string;
  templates: RewardTemplate[];
}> = ({ name, templates }) => (
  <Card
    size="lg"
    title={`Reward Templates – ${name}`}
    options={
      <CardOptions>
        <CardCloseButton />
      </CardOptions>
    }
  >
    {templates.map((template, index) => {
      const commonItems = [
        {
          label: `Reward ${index + 1}`,
          value: template.__typename,
        },
        {
          label: 'Static Amount',
          value: template.staticAmount?.toString(),
        },
      ];

      if (template.dynamicAmount) {
        commonItems.push(
          {
            label: 'Max Deposit Amount',
            value: template.dynamicAmount.maxDepositAmount?.toString(),
          },
          {
            label: 'Multiplier',
            value: `x${template.dynamicAmount.multiplier}`,
          },
          {
            label: 'Max Reward Amount',
            value: template.dynamicAmount.maxRewardAmount?.toString(),
          },
        );
      }

      const typeSpecificItems = getTypeSpecificItems(template);
      const allItems = [...commonItems, ...typeSpecificItems];

      return <DetailList key={index} items={allItems} />;
    })}
  </Card>
);

export default RewardTemplates;
